import { Component, OnInit } from '@angular/core'

@Component({
    selector: './spectrum-monitoring-faq',
    templateUrl: './spectrum-monitoring-faq.component.html',
    styleUrls: ['../../../../../help.component.css']
})

export class SpectrumMonitoringFAQComponent implements OnInit {

    ngOnInit() {

    }
}